// extracted by mini-css-extract-plugin
export var table = "_yl-0";